import type { Input } from '@builder.io/sdk';

export const statsFields = [
  {
    name: 'title',
    type: 'string',
  },
  {
    name: 'body',
    type: 'string',
  },
] as const satisfies DeepReadonly<Input[]>;

export const createFeaturedStats = (showIf?: string): DeepReadonly<Input[]> => [
  {
    name: 'featuredStats',
    type: 'list',
    subFields: statsFields,
    showIf,
  },
];
